import { z } from "zod/v4-mini";

import { TandemEventDefinition } from "../TandemTypes";

export type profileEdit1Payload = {
  idp?: number;
  status?: number;
  source_idp?: number;
  name_start?: number;
};

export type profileEdit1Event = {
  operation: "new" | "copy" | "delete" | "activate" | "rename" | "unknown";
  idp?: number;
  sourceIdp?: number;
  nameStart?: number;
};

const profileEdit1Schema = z.object({});

export const LID_IDP = {
  value: 0x45,
  name: "Personal Profile Add/Delete Event 1 of 2",
  format: "bbb.....8Z",
  fields: ["idp", "status", "source_idp", "name_start"],

  postprocess: rec => ({
    operation:
      rec.status === 0
        ? "new"
        : rec.status === 1
          ? "copy"
          : rec.status === 2
            ? "delete"
            : rec.status === 3
              ? "activate"
              : rec.status === 4
                ? "rename"
                : "unknown",
    idp: rec.idp,
    sourceIdp: rec.source_idp,
    nameStart: rec.name_start,
  }),
  schema: profileEdit1Schema,
} as const satisfies TandemEventDefinition<profileEdit1Payload, profileEdit1Event>;
